import { ytVueGlobalStore } from "@/services/yt-vue-global-store";

const menu = ytVueGlobalStore.instantGet('menu');
export default {
  namespaced: true,
  state: {
    menu: menu || "",
  },
};
